import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75066 5.25C5.81589 5.25 5.12573 6.03743 5.12573 6.92308C5.12573 7.80861 5.81585 8.59615 6.75066 8.59615C7.68547 8.59615 8.37558 7.80861 8.37558 6.92308C8.37558 6.03743 7.68543 5.25 6.75066 5.25ZM17.2498 5.25C16.3151 5.25 15.6248 6.03739 15.6248 6.92308C15.6248 7.80865 16.3151 8.59615 17.2498 8.59615C18.1845 8.59615 18.8747 7.80865 18.8747 6.92308C18.8747 6.03739 18.1844 5.25 17.2498 5.25ZM9.89282 13.6843C9.89282 12.282 10.905 11.2764 12 11.2764C13.0949 11.2764 14.1071 12.282 14.1071 13.6843V16.8422C14.1071 18.2444 13.0949 19.2501 12 19.2501C10.905 19.2501 9.89282 18.2444 9.89282 16.8422V13.6843ZM12 9.77637C9.93889 9.77637 8.39282 11.5983 8.39282 13.6843V16.8422C8.39282 18.9281 9.93889 20.7501 12 20.7501C14.061 20.7501 15.6071 18.9281 15.6071 16.8422V13.6843C15.6071 11.5983 14.061 9.77637 12 9.77637Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
